/**
 * Paths that stay public when "Login required" is ON (Admin → Configuration).
 * Ticket purchase pages are always exempt — no login needed to buy tickets.
 *
 * All exact paths MUST be lowercase; use normalizePath() before comparing.
 */
export const LOGIN_EXEMPT_EXACT_PATHS = [
  '/login',
  '/signup',
  '/guest-setup',
  '/verify-email',
  '/reset-password',
  '/auth/callback',
  '/404notfound',
  '/unauthorized',
  '/spectate',
  '/tickets',
  '/tickets/success',
  '/adminlogin',
  '/sp-login',
  '/adminhomepage',
  '/adminconfig',
  '/adminrequestcompact',
  '/adminplaylist',
  '/adminrequests',
  '/songqrequests',
  '/analytics',
  '/allsongscreen',
  '/duplicatesongs',
  '/lookuptabs',
  '/allplaylistscreen',
  '/importedsongs',
  '/adminquiz',
  '/adminlookup',
  '/adminquizimport',
  '/adminaiqgen',
];

export const normalizePath = (pathname) =>
  (pathname || '').split('?')[0].split('#')[0].toLowerCase();

/** Public ticket listing, purchase, and success pages */
export const isTicketPath = (pathname) => {
  const path = normalizePath(pathname);
  return path === '/tickets' || path === '/tickets/success' || path.startsWith('/tickets/');
};

/** Admin-only routes that do not start with /admin */
const ADMIN_PATHS_WITHOUT_PREFIX = new Set([
  '/sp-login',
  '/analytics',
  '/allsongscreen',
  '/duplicatesongs',
  '/lookuptabs',
  '/allplaylistscreen',
  '/importedsongs',
  '/requestedsongs',
  '/songqrequests',
]);

/** True for admin-panel pages (host dashboards, gig mode, sound system). */
export const isAdminAppPath = (pathname) => {
  const path = normalizePath(pathname);
  if (path.startsWith('/admin')) return true;
  if (path.startsWith('/playlists/')) return true;
  return ADMIN_PATHS_WITHOUT_PREFIX.has(path);
};

/** Auth / account screens where prize popups should never interrupt. */
const PRIZE_POPUP_BLOCKED_EXACT = new Set([
  '/login',
  '/signup',
  '/guest-setup',
  '/verify-email',
  '/reset-password',
  '/auth/callback',
  '/adminlogin',
  '/sp-login',
]);

/** True when the prize reveal overlay must stay hidden (login + ticketing). */
export const isPrizePopupBlockedPath = (pathname) => {
  const path = normalizePath(pathname);
  if (PRIZE_POPUP_BLOCKED_EXACT.has(path)) return true;
  if (isTicketPath(pathname)) return true;
  return false;
};

/** True when user may access this route without logging in (login-required guard) */
export const isLoginExemptPath = (pathname) => {
  const path = normalizePath(pathname);
  if (LOGIN_EXEMPT_EXACT_PATHS.includes(path)) return true;
  if (path.startsWith('/admin')) return true;
  if (path.startsWith('/playlists/')) return true;
  if (isTicketPath(pathname)) return true;
  return false;
};
